import { GridInitialState, gridClasses } from "@mui/x-data-grid";

const tableHeaderStyles = {
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "normal",
  color: "text.secondary",
};

export const usersDataGridInitialState: GridInitialState = {
  pagination: { paginationModel: { pageSize: 10, page: 0 } },
};

export const usersDataGridSlotProps = {
  loadingOverlay: {
    variant: "linear-progress" as const,
    noRowsVariant: "skeleton" as const,
  },
};

export const usersDataGridSx = {
  borderRadius: 2,
  border: "none",
  backgroundColor: "background.paper",
  cursor: "pointer",
  [`& .${gridClasses.columnSeparator}`]: {
    display: "none",
  },
  [`& .${gridClasses.columnHeader}`]: {
    ...tableHeaderStyles,
    backgroundColor: "background.lighter",
    borderBottom: "none !important",
  },
  [`& .${gridClasses.footerContainer}`]: {
    backgroundColor: "background.lighter",
    borderTop: "none !important",
    backgroundImage: "none",
  },
  [`& .${gridClasses.columnHeader}:focus`]: {
    outline: "none",
  },
  [`& .${gridClasses.columnHeader}:focus-within`]: {
    outline: "none",
  },
  [`& .${gridClasses.cell}:focus`]: {
    outline: "none",
  },
  [`& .${gridClasses.cell}:focus-within`]: {
    outline: "none",
  },
  "& .MuiDataGrid-row--borderBottom": {
    borderBottom: "none",
  },
};

export const getRowClassName = (params: {
  indexRelativeToCurrentPage: number;
}) => (params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd");
